<template>
  <div class="movie-entry-container">
    <!-- 页面标题 -->
    <div class="title-section">
      <div >
        <img src="static/image/logo.png" alt="logo" class="logo-section">
      </div>
      <h1>電影申報 Movie Entry</h1>
    </div>
  <el-form  :model="formData" label-position="top" label-width="120px" :rules="movieRules" ref="movieForm" style="margin-top: 10px;">
    <!-- 手风琴式表单 -->
    <el-collapse v-model="activeCollapse" accordion>
      <!-- 申報須知 -->
      <el-collapse-item  name="0">
        <template slot="title" >
          <div class="font-bold f-16">
          申報須知 Submission Guidelines
          </div>
        </template>
        <div class="form-section">
          <div v-html="agreement_content"></div>
          <div class="checkbox-group">
            
            <el-form-item  prop="agreed">
              <el-checkbox v-model="agreed">
                <div><span class='submission-font-red'>*</span> 我已閱讀規則並同意遵守。I have read the rules and agree to abide by them.</div>
              </el-checkbox>
            </el-form-item>
          </div>
        </div>
      </el-collapse-item>

      <!-- 影片信息 -->
      <el-collapse-item  name="1">
        <template slot="title" >
          <div class="font-bold f-16">
            影片信息 Movie Info
          </div>
        </template>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="電影名稱 Movie Title" prop="title">
            <el-input v-model="formData.title"></el-input>
          </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="電影類型 Genre" prop="cate">
            <el-input v-model="formData.cate"></el-input>
          </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="國家 Country" prop="country">
              <el-input v-model="formData.country"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="語言 Language" prop="language">
              <el-input v-model="formData.language"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="是否有字幕 Subtitled ( 如無中文字幕，請上傳英文字幕文檔 If there are no Chinese subtitles, please
upload an English subtitle file)" prop="subtitled">
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-radio v-model="formData.subtitled" label="YES">有字幕 Yes</el-radio>
                  <el-radio v-model="formData.subtitled" label="NO">無字幕 No</el-radio>
                  <!-- <el-input v-model="formData.subtitled"></el-input> -->
                  <!-- <el-select v-model="formData.subtitled" placeholder="請選擇 Please select">
                      <el-option key="是" label="是" value="是"></el-option>
                      <el-option key="否" label="否" value="否"></el-option>                    
                  </el-select> -->
                </el-col>
                <el-col :span="12" v-if="formData.subtitled!='YES'">
                  <el-upload
                    :action="upload_url"
                    :before-upload="handleBeforeUpload"
                    :on-success="handleSuccess"
                    :on-error="handleError"
                    :on-change="handleFileChange"
                    :limit="1"
                    accept="file/*"
                    :data="{'field':'subtitled_file'}"
                  >
                    <el-button size="small" plain type="default" style="height: 35px;line-height: 35px;padding:1px 10px;">點擊上傳字幕文檔 Click to upload subtitle file</el-button>
                  </el-upload>
                  
                </el-col>
              </el-row>
              
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="首映時間 premiere date" prop="year_produced">
              <el-input v-model="formData.year_produced"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="片長（分鐘） Length (minutes) " prop="length">
              <el-input-number v-model.number="formData.length" :min="1"></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
          <el-form-item label="一句話梗概 One-sentence Summary " prop="summary">
            <el-input v-model="formData.summary"></el-input>
          </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
          <el-form-item label="電影簡介 Movie Description " prop="description">
            <el-input type="textarea" :rows="4" v-model="formData.description"></el-input>
          </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
          <el-form-item label="曾獲獎項 Previous Awards">
            <el-input type="textarea" :rows="3" v-model="formData.awards" placeholder="多於一個獎項請用逗號分隔"></el-input>
          </el-form-item>
          </el-col>
        </el-row>

      </el-collapse-item>

      <!-- 演職人員信息 -->
      <el-collapse-item title="" name="2">
        <template slot="title" >
          <div class="font-bold f-16">
            演職人員信息 Cast and Crew
          </div>
        </template>
        <div class="">
          <p>請填寫姓名、上傳照片、上傳簡曆。Please enter the name and upload a photo and resume.</p>
        </div>
          <!-- 出品人 -->
           <div class="mb-10 f-14">出品人 Executive Producer</div>
            <el-row :gutter="20">
              <el-col :span="6">
                    <div class="sub-title"><span class='font-red'>*</span>1.</div>
                    <div class="input-upload">
                      <el-form-item prop="executive_producer1">
                        <el-input v-model="formData.executive_producer1" placeholder="" class="input-h-35" maxlength="100"></el-input>
                      </el-form-item>
                      <el-form-item prop="executive_producer1_avatar" class="input-upload-avatar">
                        <el-upload
                          class="avatar-uploader"
                          :action="upload_url"
                          :before-upload="handleBeforeUpload"
                          accept="image/*"
                          :show-file-list="false"
                          :on-success="handleSuccess"
                          :on-error="handleError"
                          :on-change="handleFileChange"
                          :data="{'field':'executive_producer1_avatar'}"
                        >
                        <img v-if="formData.executive_producer1_avatar" :src="formData.executive_producer1_avatar" class="upload-img">
                        <i v-else class="el-icon-user upload-plus"><span class="font-red">*</span></i>
                        </el-upload>
                      </el-form-item>
                      <el-form-item prop="executive_producer1_resume" class="input-upload-avatar">
                        <el-upload
                          class="avatar-uploader"
                          :action="upload_url"
                          :before-upload="handleBeforeUpload"
                          accept="file/*"
                          :show-file-list="false"
                          :on-success="handleSuccess"
                          :on-error="handleError"
                          :on-change="handleFileChange"
                          :data="{'field':'executive_producer1_resume'}"
                        >
                        <i v-if="formData.executive_producer1_resume" class="el-icon-circle-check upload-plus"></i>
                        <i v-else class="el-icon-document upload-plus"></i>
                        </el-upload>
                      </el-form-item>
                    </div>
              </el-col>
              <el-col :span="6">
                <el-form-item>
                  <div class="sub-title">2.</div>
                    <div class="input-upload">
                      <el-input v-model="formData.executive_producer2" placeholder="" maxlength="100"></el-input>
                      <el-upload
                        class="avatar-uploader"
                        :action="upload_url"
                        :before-upload="handleBeforeUpload"
                        accept="image/*"
                        :show-file-list="false"
                        :on-success="handleSuccess"
                        :on-error="handleError"
                        :on-change="handleFileChange"
                        :data="{'field':'executive_producer2_avatar'}"
                      >
                      <img v-if="formData.executive_producer2_avatar" :src="formData.executive_producer2_avatar" class="upload-img">
                      <i v-else class="el-icon-user upload-plus"></i>
                      </el-upload>
                      
                      <el-upload
                        class="avatar-uploader"
                        :action="upload_url"
                        :before-upload="handleBeforeUpload"
                        accept="file/*"
                        :show-file-list="false"
                        :on-success="handleSuccess"
                        :on-error="handleError"
                        :on-change="handleFileChange"
                        :data="{'field':'executive_producer2_resume'}"
                      >
                      <i v-if="formData.executive_producer2_resume" class="el-icon-circle-check upload-plus"></i>
                      <i v-else class="el-icon-document upload-plus"></i>
                      </el-upload>
                    </div>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="">
                  <div class="sub-title">3.</div>
                    <div class="input-upload">
                      <el-input v-model="formData.executive_producer3" placeholder="" maxlength="100"></el-input>
                      <el-upload
                        class="avatar-uploader"
                        :action="upload_url"
                        :before-upload="handleBeforeUpload"
                        accept="image/*"
                        :show-file-list="false"
                        :on-success="handleSuccess"
                        :on-error="handleError"
                        :on-change="handleFileChange"
                        :data="{'field':'executive_producer3_avatar'}"
                      >
                      <img v-if="formData.executive_producer3_avatar" :src="formData.executive_producer3_avatar" class="upload-img">
                      <i v-else class="el-icon-user upload-plus"></i>
                      </el-upload>
                      <el-upload
                        class="avatar-uploader"
                        :action="upload_url"
                        :before-upload="handleBeforeUpload"
                        accept="file/*"
                        :show-file-list="false"
                        :on-success="handleSuccess"
                        :on-error="handleError"
                        :on-change="handleFileChange"
                        :data="{'field':'executive_producer3_resume'}"
                      >
                      <i v-if="formData.executive_producer3_resume" class="el-icon-circle-check upload-plus"></i>
                      <i v-else class="el-icon-document upload-plus"></i>
                      </el-upload>
                    </div>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="">
                  <div class="sub-title">更多 More</div>
                    <div class="input-upload">
                      <el-input v-model="formData.executive_producer_more" placeholder="以逗號分隔 separate with comm" ></el-input>
                    </div>
                </el-form-item>
              </el-col>
            </el-row>

          <!-- 导演 -->
           <div class="mb-10 f-14">導演 Director</div>
            <el-row :gutter="20">
              <el-col :span="6">
                    <div class="sub-title"><span class='font-red'>*</span>1. </div>
                    <div class="input-upload">
                      <el-form-item prop="director1">
                        <el-input v-model="formData.director1" placeholder="" maxlength="100"></el-input>
                      </el-form-item>
                      <el-form-item prop="director1_avatar" class="input-upload-avatar">
                        <el-upload
                          class="avatar-uploader"
                          :action="upload_url"
                          :before-upload="handleBeforeUpload"
                          accept="image/*"
                          :show-file-list="false"
                          :on-success="handleSuccess"
                          :on-error="handleError"
                          :on-change="handleFileChange"
                          :data="{'field':'director1_avatar'}"
                        >
                        <img v-if="formData.director1_avatar" :src="formData.director1_avatar" class="upload-img">
                        <i v-else class="el-icon-user upload-plus"><span class="font-red">*</span></i>
                        </el-upload>
                      </el-form-item>
                      
                      <el-form-item prop="director1_resume" class="input-upload-avatar">
                        <el-upload
                          class="avatar-uploader"
                          :action="upload_url"
                          :before-upload="handleBeforeUpload"
                          accept="file/*"
                          :show-file-list="false"
                          :on-success="handleSuccess"
                          :on-error="handleError"
                          :on-change="handleFileChange"
                          :data="{'field':'director1_resume'}"
                        >
                        <i v-if="formData.director1_resume" class="el-icon-circle-check upload-plus"></i>
                        <i v-else class="el-icon-document upload-plus"></i>
                        </el-upload>
                      </el-form-item>
                    </div>
              </el-col>
              <el-col :span="6">
                <el-form-item>
                  <div class="sub-title">2.</div>
                    <div class="input-upload">
                      <el-input v-model="formData.director2" placeholder="" maxlength="100"></el-input>
                      <el-upload
                        class="avatar-uploader"
                        :action="upload_url"
                        :before-upload="handleBeforeUpload"
                        accept="image/*"
                        :show-file-list="false"
                        :on-success="handleSuccess"
                        :on-error="handleError"
                        :on-change="handleFileChange"
                        :data="{'field':'director2_avatar'}"
                      >
                      <img v-if="formData.director2_avatar" :src="formData.director2_avatar" class="upload-img">
                      <i v-else class="el-icon-user upload-plus"></i>
                      </el-upload>
                      <el-upload
                        class="avatar-uploader"
                        :action="upload_url"
                        :before-upload="handleBeforeUpload"
                        accept="file/*"
                        :show-file-list="false"
                        :on-success="handleSuccess"
                        :on-error="handleError"
                        :on-change="handleFileChange"
                        :data="{'field':'director2_resume'}"
                      >
                      <i v-if="formData.director2_resume" class="el-icon-circle-check upload-plus"></i>
                      <i v-else class="el-icon-document upload-plus"></i>
                      </el-upload>
                    </div>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="">
                  <div class="sub-title">3.</div>
                    <div class="input-upload">
                      <el-input v-model="formData.director3" placeholder="" maxlength="100"></el-input>
                      <el-upload
                        class="avatar-uploader"
                        :action="upload_url"
                        :before-upload="handleBeforeUpload"
                        accept="image/*"
                        :show-file-list="false"
                        :on-success="handleSuccess"
                        :on-error="handleError"
                        :on-change="handleFileChange"
                        :data="{'field':'director3_avatar'}"
                      >
                      <img v-if="formData.director3_avatar" :src="formData.director3_avatar" class="upload-img">
                      <i v-else class="el-icon-user upload-plus"></i>
                      </el-upload>
                      <el-upload
                        class="avatar-uploader"
                        :action="upload_url"
                        :before-upload="handleBeforeUpload"
                        accept="file/*"
                        :show-file-list="false"
                        :on-success="handleSuccess"
                        :on-error="handleError"
                        :on-change="handleFileChange"
                        :data="{'field':'director3_resume'}"
                      >
                      <i v-if="formData.director3_resume" class="el-icon-circle-check upload-plus"></i>
                      <i v-else class="el-icon-document upload-plus"></i>
                      </el-upload>
                    </div>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="">
                  <div class="sub-title">更多 More</div>
                    <div class="input-upload">
                      <el-input v-model="formData.director_more" placeholder="以逗號分隔 separate with comm" ></el-input>
                    </div>
                </el-form-item>
              </el-col>
            </el-row>

            <div class="mb-10 f-14">編劇 Screenwriter</div>
            <el-row :gutter="20">
              <el-col :span="6">
                    <div class="sub-title"><span class='font-red'>*</span>1. </div>
                    <div class="input-upload">
                      <el-form-item prop="screenwriter1">
                        <el-input v-model="formData.screenwriter1" placeholder="" maxlength="100"></el-input>
                      </el-form-item>
                      <el-form-item prop="screenwriter1_avatar">
                        <el-upload
                          class="avatar-uploader"
                          :action="upload_url"
                          :before-upload="handleBeforeUpload"
                          accept="image/*"
                          :show-file-list="false"
                          :on-success="handleSuccess"
                          :on-error="handleError"
                          :on-change="handleFileChange"
                          :data="{'field':'screenwriter1_avatar'}"
                        >
                        <img v-if="formData.screenwriter1_avatar" :src="formData.screenwriter1_avatar" class="upload-img">
                        <i v-else class="el-icon-user upload-plus"><span class="font-red">*</span></i>
                        </el-upload>
                      </el-form-item>
                      <el-form-item prop="screenwriter1_resume">
                        <el-upload
                          class="avatar-uploader"
                          :action="upload_url"
                          :before-upload="handleBeforeUpload"
                          accept="file/*"
                          :show-file-list="false"
                          :on-success="handleSuccess"
                          :on-error="handleError"
                          :on-change="handleFileChange"
                          :data="{'field':'screenwriter1_resume'}"
                        >
                        <i v-if="formData.screenwriter1_resume" class="el-icon-circle-check upload-plus"></i>
                        <i v-else class="el-icon-document upload-plus"></i>
                        </el-upload>
                      </el-form-item>
                    </div>
              </el-col>
              <el-col :span="6">
                <el-form-item>
                  <div class="sub-title">2.</div>
                    <div class="input-upload">
                      <el-input v-model="formData.screenwriter2" placeholder="" maxlength="100"></el-input>
                      <el-upload
                        class="avatar-uploader"
                        :action="upload_url"
                        :before-upload="handleBeforeUpload"
                        accept="image/*"
                        :show-file-list="false"
                        :on-success="handleSuccess"
                        :on-error="handleError"
                        :on-change="handleFileChange"
                        :data="{'field':'screenwriter2_avatar'}"
                      >
                      <img v-if="formData.screenwriter2_avatar" :src="formData.screenwriter2_avatar" class="upload-img">
                      <i v-else class="el-icon-user upload-plus"></i>
                      </el-upload>
                      <el-upload
                        class="avatar-uploader"
                        :action="upload_url"
                        :before-upload="handleBeforeUpload"
                        accept="file/*"
                        :show-file-list="false"
                        :on-success="handleSuccess"
                        :on-error="handleError"
                        :on-change="handleFileChange"
                        :data="{'field':'screenwriter2_resume'}"
                      >
                      <i v-if="formData.screenwriter2_resume" class="el-icon-circle-check upload-plus"></i>
                      <i v-else class="el-icon-document upload-plus"></i>
                      </el-upload>
                    </div>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="">
                  <div class="sub-title">3.</div>
                    <div class="input-upload">
                      <el-input v-model="formData.screenwriter3" placeholder="" maxlength="100"></el-input>
                      <el-upload
                        class="avatar-uploader"
                        :action="upload_url"
                        :before-upload="handleBeforeUpload"
                        accept="image/*"
                        :show-file-list="false"
                        :on-success="handleSuccess"
                        :on-error="handleError"
                        :on-change="handleFileChange"
                        :data="{'field':'screenwriter3_avatar'}"
                      >
                      <img v-if="formData.screenwriter3_avatar" :src="formData.screenwriter3_avatar" class="upload-img">
                      <i v-else class="el-icon-user upload-plus"></i>
                      </el-upload>
                      <el-upload
                        class="avatar-uploader"
                        :action="upload_url"
                        :before-upload="handleBeforeUpload"
                        accept="file/*"
                        :show-file-list="false"
                        :on-success="handleSuccess"
                        :on-error="handleError"
                        :on-change="handleFileChange"
                        :data="{'field':'screenwriter3_resume'}"
                      >
                      <i v-if="formData.screenwriter3_resume" class="el-icon-circle-check upload-plus"></i>
                      <i v-else class="el-icon-document upload-plus"></i>
                      </el-upload>
                    </div>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="">
                  <div class="sub-title">更多 More</div>
                    <div class="input-upload">
                      <el-input v-model="formData.screenwriter_more" placeholder="以逗號分隔 separate with comm" ></el-input>
                    </div>
                </el-form-item>
              </el-col>
            </el-row>

            <div class="mb-10 f-14">演員 Actor</div>
            <el-row :gutter="20">
              <el-col :span="6">
                  <el-form-item prop="actor1">
                    <div class="sub-title"><span class='font-red'>*</span> 1. </div>
                    <div class="input-upload">
                      <el-input v-model="formData.actor1" placeholder="" maxlength="100"></el-input>
                      <el-upload
                        class="avatar-uploader"
                        :action="upload_url"
                        :before-upload="handleBeforeUpload"
                        accept="image/*"
                        :show-file-list="false"
                        :on-success="handleSuccess"
                        :on-error="handleError"
                        :on-change="handleFileChange"
                        :data="{'field':'actor1_avatar'}"
                      >
                      <img v-if="formData.actor1_avatar" :src="formData.actor1_avatar" class="upload-img">
                      <i v-else class="el-icon-user upload-plus"></i>
                      </el-upload>
                      <el-upload
                        class="avatar-uploader"
                        :action="upload_url"
                        :before-upload="handleBeforeUpload"
                        accept="file/*"
                        :show-file-list="false"
                        :on-success="handleSuccess"
                        :on-error="handleError"
                        :on-change="handleFileChange"
                        :data="{'field':'actor1_resume'}"
                      >
                      <i v-if="formData.actor1_resume" class="el-icon-circle-check upload-plus"></i>
                      <i v-else class="el-icon-document upload-plus"></i>
                      </el-upload>
                    </div>
                  </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item prop="actor2" >
                  <div class="sub-title"><span class='font-red'>*</span> 2. </div>
                    <div class="input-upload">
                      <el-input v-model="formData.actor2" placeholder="" maxlength="100"></el-input>
                      <el-upload
                        class="avatar-uploader"
                        :action="upload_url"
                        :before-upload="handleBeforeUpload"
                        accept="image/*"
                        :show-file-list="false"
                        :on-success="handleSuccess"
                        :on-error="handleError"
                        :on-change="handleFileChange"
                        :data="{'field':'actor2_avatar'}"
                      >
                      <img v-if="formData.actor2_avatar" :src="formData.actor2_avatar" class="upload-img">
                      <i v-else class="el-icon-user upload-plus"></i>
                      </el-upload>
                      <el-upload
                        class="avatar-uploader"
                        :action="upload_url"
                        :before-upload="handleBeforeUpload"
                        accept="file/*"
                        :show-file-list="false"
                        :on-success="handleSuccess"
                        :on-error="handleError"
                        :on-change="handleFileChange"
                        :data="{'field':'actor2_resume'}"
                      >
                      <i v-if="formData.actor2_resume" class="el-icon-circle-check upload-plus"></i>
                      <i v-else class="el-icon-document upload-plus"></i>
                      </el-upload>
                    </div>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="">
                  <div class="sub-title">3.</div>
                    <div class="input-upload">
                      <el-input v-model="formData.actor3" placeholder="" maxlength="100"></el-input>
                      <el-upload
                        class="avatar-uploader"
                        :action="upload_url"
                        :before-upload="handleBeforeUpload"
                        accept="image/*"
                        :show-file-list="false"
                        :on-success="handleSuccess"
                        :on-error="handleError"
                        :on-change="handleFileChange"
                        :data="{'field':'actor3_avatar'}"
                      >
                      <img v-if="formData.actor3_avatar" :src="formData.actor3_avatar" class="upload-img">
                      <i v-else class="el-icon-user upload-plus"></i>
                      </el-upload>
                      <el-upload
                        class="avatar-uploader"
                        :action="upload_url"
                        :before-upload="handleBeforeUpload"
                        accept="file/*"
                        :show-file-list="false"
                        :on-success="handleSuccess"
                        :on-error="handleError"
                        :on-change="handleFileChange"
                        :data="{'field':'actor3_resume'}"
                      >
                      <i v-if="formData.actor3_resume" class="el-icon-circle-check upload-plus"></i>
                      <i v-else class="el-icon-document upload-plus"></i>
                      </el-upload>
                    </div>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="">
                  <div class="sub-title">4.</div>
                    <div class="input-upload">
                      <el-input v-model="formData.actor4" placeholder="" maxlength="100"></el-input>
                      <el-upload
                        class="avatar-uploader"
                        :action="upload_url"
                        :before-upload="handleBeforeUpload"
                        accept="image/*"
                        :show-file-list="false"
                        :on-success="handleSuccess"
                        :on-error="handleError"
                        :on-change="handleFileChange"
                        :data="{'field':'actor4_avatar'}"
                      >
                      <img v-if="formData.actor4_avatar" :src="formData.actor4_avatar" class="upload-img">
                      <i v-else class="el-icon-user upload-plus"></i>
                      </el-upload>
                      <el-upload
                        class="avatar-uploader"
                        :action="upload_url"
                        :before-upload="handleBeforeUpload"
                        accept="file/*"
                        :show-file-list="false"
                        :on-success="handleSuccess"
                        :on-error="handleError"
                        :on-change="handleFileChange"
                        :data="{'field':'actor4_resume'}"
                      >
                      <i v-if="formData.actor4_resume" class="el-icon-circle-check upload-plus"></i>
                      <i v-else class="el-icon-document upload-plus"></i>
                      </el-upload>
                    </div>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="6">
                  <el-form-item >
                    <div class="sub-title">5.</div>
                    <div class="input-upload">
                      <el-input v-model="formData.actor5" placeholder="" maxlength="100"></el-input>
                      <el-upload
                        class="avatar-uploader"
                        :action="upload_url"
                        :before-upload="handleBeforeUpload"
                        accept="image/*"
                        :show-file-list="false"
                        :on-success="handleSuccess"
                        :on-error="handleError"
                        :on-change="handleFileChange"
                        :data="{'field':'actor5_avatar'}"
                      >
                      <img v-if="formData.actor5_avatar" :src="formData.actor5_avatar" class="upload-img">
                      <i v-else class="el-icon-user upload-plus"></i>
                      </el-upload>
                      <el-upload
                        class="avatar-uploader"
                        :action="upload_url"
                        :before-upload="handleBeforeUpload"
                        accept="file/*"
                        :show-file-list="false"
                        :on-success="handleSuccess"
                        :on-error="handleError"
                        :on-change="handleFileChange"
                        :data="{'field':'actor5_resume'}"
                      >
                      <i v-if="formData.actor5_resume" class="el-icon-circle-check upload-plus"></i>
                      <i v-else class="el-icon-document upload-plus"></i>
                      </el-upload>
                    </div>
                  </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item>
                  <div class="sub-title">6.</div>
                    <div class="input-upload">
                      <el-input v-model="formData.actor6" placeholder="" maxlength="100"></el-input>
                      <el-upload
                        class="avatar-uploader"
                        :action="upload_url"
                        :before-upload="handleBeforeUpload"
                        accept="image/*"
                        :show-file-list="false"
                        :on-success="handleSuccess"
                        :on-error="handleError"
                        :on-change="handleFileChange"
                        :data="{'field':'actor6_avatar'}"
                      >
                      <img v-if="formData.actor6_avatar" :src="formData.actor6_avatar" class="upload-img">
                      <i v-else class="el-icon-user upload-plus"></i>
                      </el-upload>
                      <el-upload
                        class="avatar-uploader"
                        :action="upload_url"
                        :before-upload="handleBeforeUpload"
                        accept="file/*"
                        :show-file-list="false"
                        :on-success="handleSuccess"
                        :on-error="handleError"
                        :on-change="handleFileChange"
                        :data="{'field':'actor6_resume'}"
                      >
                      <i v-if="formData.actor6_resume" class="el-icon-circle-check upload-plus"></i>
                      <i v-else class="el-icon-document upload-plus"></i>
                      </el-upload>
                    </div>
                </el-form-item>
              </el-col><el-col :span="6">
                <el-form-item label="">
                  <div class="sub-title">更多 More</div>
                  <el-input v-model="formData.actor_more" placeholder="以逗號分隔 separate with comm"></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <div class="mb-10 f-14">製作人 Producer</div>
            <el-row :gutter="20">
              <el-col :span="6">
                    <div class="sub-title"><span class='font-red'>*</span>1. </div>
                    <div class="input-upload">
                      <el-form-item prop="producer1">
                        <el-input v-model="formData.producer1" placeholder="" maxlength="100"></el-input>
                      </el-form-item>
                      <el-form-item prop="producer1_avatar">
                        <el-upload
                          class="avatar-uploader"
                          :action="upload_url"
                          :before-upload="handleBeforeUpload"
                          accept="image/*"
                          :show-file-list="false"
                          :on-success="handleSuccess"
                          :on-error="handleError"
                          :on-change="handleFileChange"
                          :data="{'field':'producer1_avatar'}"
                        >
                        <img v-if="formData.producer1_avatar" :src="formData.producer1_avatar" class="upload-img">
                        <i v-else class="el-icon-user upload-plus"><span class="font-red">*</span></i>
                        </el-upload>
                      </el-form-item>
                      <el-form-item prop="producer1_resume">
                        <el-upload
                          class="avatar-uploader"
                          :action="upload_url"
                          :before-upload="handleBeforeUpload"
                          accept="file/*"
                          :show-file-list="false"
                          :on-success="handleSuccess"
                          :on-error="handleError"
                          :on-change="handleFileChange"
                          :data="{'field':'producer1_resume'}"
                        >
                        <i v-if="formData.producer1_resume" class="el-icon-circle-check upload-plus"></i>
                        <i v-else class="el-icon-document upload-plus"></i>
                        </el-upload>
                      </el-form-item>
                    </div>
              </el-col>
              <el-col :span="6">
                <el-form-item>
                  <div class="sub-title">2.</div>
                    <div class="input-upload">
                      <el-input v-model="formData.producer2" placeholder="" maxlength="100"></el-input>
                      <el-upload
                        class="avatar-uploader"
                        :action="upload_url"
                        :before-upload="handleBeforeUpload"
                        accept="image/*"
                        :show-file-list="false"
                        :on-success="handleSuccess"
                        :on-error="handleError"
                        :on-change="handleFileChange"
                        :data="{'field':'producer2_avatar'}"
                      >
                      <img v-if="formData.producer2_avatar" :src="formData.producer2_avatar" class="upload-img">
                      <i v-else class="el-icon-user upload-plus"></i>
                      </el-upload>
                      <el-upload
                        class="avatar-uploader"
                        :action="upload_url"
                        :before-upload="handleBeforeUpload"
                        accept="file/*"
                        :show-file-list="false"
                        :on-success="handleSuccess"
                        :on-error="handleError"
                        :on-change="handleFileChange"
                        :data="{'field':'producer2_resume'}"
                      >
                      <i v-if="formData.producer2_resume" class="el-icon-circle-check upload-plus"></i>
                      <i v-else class="el-icon-document upload-plus"></i>
                      </el-upload>
                    </div>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="">
                  <div class="sub-title">3.</div>
                    <div class="input-upload">
                      <el-input v-model="formData.producer3" placeholder="" maxlength="100"></el-input>
                      <el-upload
                        class="avatar-uploader"
                        :action="upload_url"
                        :before-upload="handleBeforeUpload"
                        accept="image/*"
                        :show-file-list="false"
                        :on-success="handleSuccess"
                        :on-error="handleError"
                        :on-change="handleFileChange"
                        :data="{'field':'producer3_avatar'}"
                      >
                      <img v-if="formData.producer3_avatar" :src="formData.producer3_avatar" class="upload-img">
                      <i v-else class="el-icon-user upload-plus"></i>
                      </el-upload>
                      <el-upload
                        class="avatar-uploader"
                        :action="upload_url"
                        :before-upload="handleBeforeUpload"
                        accept="file/*"
                        :show-file-list="false"
                        :on-success="handleSuccess"
                        :on-error="handleError"
                        :on-change="handleFileChange"
                        :data="{'field':'producer3_resume'}"
                      >
                      <i v-if="formData.producer3_resume" class="el-icon-circle-check upload-plus"></i>
                      <i v-else class="el-icon-document upload-plus"></i>
                      </el-upload>
                    </div>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="">
                  <div class="sub-title">更多 More</div>
                    <div class="input-upload">
                      <el-input v-model="formData.producer_more" placeholder="以逗號分隔 separate with comm" ></el-input>
                    </div>
                </el-form-item>
              </el-col>
            </el-row>

            <div class="mb-10 f-14">攝影 Cinematographer</div>
            <el-row :gutter="20">
              <el-col :span="6">
                    <div class="sub-title"><span class='font-red'>*</span>1. </div>
                    <div class="input-upload">
                      <el-form-item prop="cinematographer1">
                        <el-input v-model="formData.cinematographer1" placeholder="" maxlength="100"></el-input>
                      </el-form-item>
                      <el-form-item prop="cinematographer1_avatar">
                        <el-upload
                          class="avatar-uploader"
                          :action="upload_url"
                          :before-upload="handleBeforeUpload"
                          accept="image/*"
                          :show-file-list="false"
                          :on-success="handleSuccess"
                          :on-error="handleError"
                          :on-change="handleFileChange"
                          :data="{'field':'cinematographer1_avatar'}"
                        >
                        <img v-if="formData.cinematographer1_avatar" :src="formData.cinematographer1_avatar" class="upload-img">
                        <i v-else class="el-icon-user upload-plus"><span class="font-red">*</span></i>
                        </el-upload>
                      </el-form-item>
                      <el-form-item prop="cinematographer1_resume">
                        <el-upload
                          class="avatar-uploader"
                          :action="upload_url"
                          :before-upload="handleBeforeUpload"
                          accept="file/*"
                          :show-file-list="false"
                          :on-success="handleSuccess"
                          :on-error="handleError"
                          :on-change="handleFileChange"
                          :data="{'field':'cinematographer1_resume'}"
                        >
                        <i v-if="formData.cinematographer1_resume" class="el-icon-circle-check upload-plus"></i>
                        <i v-else class="el-icon-document upload-plus"></i>
                        </el-upload>
                      </el-form-item>
                    </div>
              </el-col>
              <el-col :span="6">
                <el-form-item>
                  <div class="sub-title">2.</div>
                    <div class="input-upload">
                      <el-input v-model="formData.cinematographer2" placeholder="" maxlength="100"></el-input>
                      <el-upload
                        class="avatar-uploader"
                        :action="upload_url"
                        :before-upload="handleBeforeUpload"
                        accept="image/*"
                        :show-file-list="false"
                        :on-success="handleSuccess"
                        :on-error="handleError"
                        :on-change="handleFileChange"
                        :data="{'field':'cinematographer2_avatar'}"
                      >
                      <img v-if="formData.cinematographer2_avatar" :src="formData.cinematographer2_avatar" class="upload-img">
                      <i v-else class="el-icon-user upload-plus"></i>
                      </el-upload>
                      <el-upload
                        class="avatar-uploader"
                        :action="upload_url"
                        :before-upload="handleBeforeUpload"
                        accept="file/*"
                        :show-file-list="false"
                        :on-success="handleSuccess"
                        :on-error="handleError"
                        :on-change="handleFileChange"
                        :data="{'field':'cinematographer2_resume'}"
                      >
                      <i v-if="formData.cinematographer2_resume" class="el-icon-circle-check upload-plus"></i>
                      <i v-else class="el-icon-document upload-plus"></i>
                      </el-upload>
                    </div>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="">
                  <div class="sub-title">3.</div>
                    <div class="input-upload">
                      <el-input v-model="formData.cinematographer3" placeholder="" maxlength="100"></el-input>
                      <el-upload
                        class="avatar-uploader"
                        :action="upload_url"
                        :before-upload="handleBeforeUpload"
                        accept="image/*"
                        :show-file-list="false"
                        :on-success="handleSuccess"
                        :on-error="handleError"
                        :on-change="handleFileChange"
                        :data="{'field':'cinematographer3_avatar'}"
                      >
                      <img v-if="formData.cinematographer3_avatar" :src="formData.cinematographer3_avatar" class="upload-img">
                      <i v-else class="el-icon-user upload-plus"></i>
                      </el-upload>
                      <el-upload
                        class="avatar-uploader"
                        :action="upload_url"
                        :before-upload="handleBeforeUpload"
                        accept="file/*"
                        :show-file-list="false"
                        :on-success="handleSuccess"
                        :on-error="handleError"
                        :on-change="handleFileChange"
                        :data="{'field':'cinematographer3_resume'}"
                      >
                      <i v-if="formData.cinematographer3_resume" class="el-icon-circle-check upload-plus"></i>
                      <i v-else class="el-icon-document upload-plus"></i>
                      </el-upload>
                    </div>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="">
                  <div class="sub-title">更多 More</div>
                    <div class="input-upload">
                      <el-input v-model="formData.cinematographer_more" placeholder="以逗號分隔 separate with comm" ></el-input>
                    </div>
                </el-form-item>
              </el-col>
            </el-row>

            <div class="mb-10 f-14">美術 Art</div>
            <el-row :gutter="20">
              <el-col :span="6">
                    <div class="sub-title"><span class='font-red'>*</span>1. </div>
                    <div class="input-upload">
                      <el-form-item prop="art1">
                        <el-input v-model="formData.art1" placeholder="" maxlength="100"></el-input>
                      </el-form-item>
                      <el-form-item prop="art1_avatar">
                        <el-upload
                          class="avatar-uploader"
                          :action="upload_url"
                          :before-upload="handleBeforeUpload"
                          accept="image/*"
                          :show-file-list="false"
                          :on-success="handleSuccess"
                          :on-error="handleError"
                          :on-change="handleFileChange"
                          :data="{'field':'art1_avatar'}"
                        >
                        <img v-if="formData.art1_avatar" :src="formData.art1_avatar" class="upload-img">
                        <i v-else class="el-icon-user upload-plus"><span class="font-red">*</span></i>
                        </el-upload>
                      </el-form-item>
                      <el-form-item prop="art1_resume">
                        <el-upload
                          class="avatar-uploader"
                          :action="upload_url"
                          :before-upload="handleBeforeUpload"
                          accept="file/*"
                          :show-file-list="false"
                          :on-success="handleSuccess"
                          :on-error="handleError"
                          :on-change="handleFileChange"
                          :data="{'field':'art1_resume'}"
                        >
                        <i v-if="formData.art1_resume" class="el-icon-circle-check upload-plus"></i>
                        <i v-else class="el-icon-document upload-plus"></i>
                        </el-upload>
                      </el-form-item>
                    </div>
              </el-col>
              <el-col :span="6">
                <el-form-item>
                  <div class="sub-title">2.</div>
                    <div class="input-upload">
                      <el-input v-model="formData.art2" placeholder="" maxlength="100"></el-input>
                      <el-upload
                        class="avatar-uploader"
                        :action="upload_url"
                        :before-upload="handleBeforeUpload"
                        accept="image/*"
                        :show-file-list="false"
                        :on-success="handleSuccess"
                        :on-error="handleError"
                        :on-change="handleFileChange"
                        :data="{'field':'art2_avatar'}"
                      >
                      <img v-if="formData.art2_avatar" :src="formData.art2_avatar" class="upload-img">
                      <i v-else class="el-icon-user upload-plus"></i>
                      </el-upload>
                      <el-upload
                        class="avatar-uploader"
                        :action="upload_url"
                        :before-upload="handleBeforeUpload"
                        accept="file/*"
                        :show-file-list="false"
                        :on-success="handleSuccess"
                        :on-error="handleError"
                        :on-change="handleFileChange"
                        :data="{'field':'art2_resume'}"
                      >
                      <i v-if="formData.art2_resume" class="el-icon-circle-check upload-plus"></i>
                      <i v-else class="el-icon-document upload-plus"></i>
                      </el-upload>
                    </div>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="">
                  <div class="sub-title">3.</div>
                    <div class="input-upload">
                      <el-input v-model="formData.art3" placeholder="" maxlength="100"></el-input>
                      <el-upload
                        class="avatar-uploader"
                        :action="upload_url"
                        :before-upload="handleBeforeUpload"
                        accept="image/*"
                        :show-file-list="false"
                        :on-success="handleSuccess"
                        :on-error="handleError"
                        :on-change="handleFileChange"
                        :data="{'field':'art3_avatar'}"
                      >
                      <img v-if="formData.art3_avatar" :src="formData.art3_avatar" class="upload-img">
                      <i v-else class="el-icon-user upload-plus"></i>
                      </el-upload>
                      <el-upload
                        class="avatar-uploader"
                        :action="upload_url"
                        :before-upload="handleBeforeUpload"
                        accept="file/*"
                        :show-file-list="false"
                        :on-success="handleSuccess"
                        :on-error="handleError"
                        :on-change="handleFileChange"
                        :data="{'field':'art3_resume'}"
                      >
                      <i v-if="formData.art3_resume" class="el-icon-circle-check upload-plus"></i>
                      <i v-else class="el-icon-document upload-plus"></i>
                      </el-upload>
                    </div>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="">
                  <div class="sub-title">更多 More</div>
                    <div class="input-upload">
                      <el-input v-model="formData.art_more" placeholder="以逗號分隔 separate with comm" ></el-input>
                    </div>
                </el-form-item>
              </el-col>
            </el-row>

      </el-collapse-item>

      <!-- 申報方信息 -->
      <el-collapse-item title="" name="3">
        <template slot="title" >
          <div class="font-bold f-16">
            申報方信息 Contact Info
          </div>
        </template>
          <el-form-item label="出品單位 Production Company" prop="company">
            <el-input v-model="formData.company" class="h-30"></el-input>
          </el-form-item>

          <el-row :gutter="20">
            <el-col :span="12">
                <el-form-item label="聯絡人 Person of Contact" prop="contact">
                  <el-input v-model="formData.contact" placeholder="" class="h-30"></el-input>
                </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="聯絡電話 Contact Number" prop="phone">
                <el-input v-model="formData.phone" placeholder="" class="h-30"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12">
                <el-form-item label="電子郵箱 Email" prop="email">
                  <el-input v-model="formData.email" placeholder="" class="h-30"></el-input>
                </el-form-item>
            </el-col>
          </el-row>

          <el-form-item label='內地影片請上傳影片公映許可證（或龍標） / 網路放映許可證 Mainland Chinese films please upload Public Screening License (or the "Dragon Label") or Online Distribution Permit' prop="business_license">
            <el-upload
              :action="upload_url"
              :before-upload="handleBeforeUpload"
              accept="image/*"
              :show-file-list="false"
              :on-success="handleSuccess"
              :on-error="handleError"
              :on-change="handleFileChange"
              list-type="picture-card"
              :data="{'field':'business_license'}"
            >
              <img v-if="formData.business_license" :src="formData.business_license" class="business-uploader">
              <i v-else class="el-icon-plus"></i>
            </el-upload>
          </el-form-item>
          <el-form-item label="承諾書 Pledge" prop="pledge">
            <div class="sub-title">請下载承諾書，打印、簽名並加蓋出品单位公章後，拍照上傳。</div>
            <div class="sub-title">Please download and print out Submission Agreement, sign it, and stamp it with the production company's official seal, then upload a photo of it.</div>
            <div class="pledge-buttons">

              <el-upload
                :action="upload_url"
                :before-upload="handleBeforeUpload"
                accept="image/*"
                :show-file-list="false"
                :on-success="handleSuccess"
                :on-error="handleError"
                :on-change="handleFileChange"
                list-type="picture-card"
                :data="{'field':'pledge'}"
              >
                <img v-if="formData.pledge" :src="formData.pledge" class="business-uploader">
                <i v-else class="el-icon-plus"></i>
              </el-upload>
            </div>
            <el-link type="primary" :underline="false" target="_blank" @click="downloadPledge" >下載承諾書 Download Submission Agreement</el-link>
          </el-form-item>
      </el-collapse-item>
      <!-- 单元类别信息 -->
      <el-collapse-item title="" name="4">
        <template slot="title" >
          <div class="font-bold f-16">
            報名選項 Sections you wish to enter
          </div>
        </template>
        <div class="">
          <div>申請人可選擇希望報名影片入圍的單元，最終的入圍名單和入圍單元由評審會決定，並由組委會在官方公佈之前與申請人溝通確認。</div>
          <div >Applicants may select the preferred section for their submitted film to be considered for. The final selection of films and their respective sections will be determined by the jury panel. The organizing committee will communicate and confirm the results with applicants prior to the official announcement.</div>
        </div>
          <div class="mt-10">
            <div class="mb-5"><el-checkbox v-model="formData.main_competition" true-label="1" false-label="0" label="金海燕獎主競賽單元 Golden Petrel Award – Main Competition Section" border></el-checkbox></div>
            <div class="tips">電影節核心單元，致力於甄選並表彰年度最具藝術高度、思想深度與美學創新的亞洲電影作品及電影人。</div>
            <div class="tips">The core section of the Festival, dedicated to selecting and recognizing Asian film works and filmmakers that demonstrate the highest level of artistic achievement, intellectual depth, and aesthetic innovation of the year.</div>
          </div>
          <div class="mt-10">
            <div class="mb-5"><el-checkbox v-model="formData.pioneer_trend" true-label="1" false-label="0" label="先鋒浪潮單元 Pioneer Wave Section" border></el-checkbox></div>
            <div class="tips">專注於發掘具有實驗性、創新性與前衛精神的電影作品。鼓勵在敘事結構、影像語言、媒介形式或技術應用上敢於挑戰常規、拓展電影藝術邊界的創作者。</div>
            <div class="tips">Dedicated to discovering film works of experimental, innovative, and avant-garde spirit. Encourages creators who dare to challenge conventions and push the boundaries of cinematic art in narrative structure, visual language, media forms, or technological applications.</div>
          </div>
          <div class="mt-10">
            <div class="mb-5"><el-checkbox v-model="formData.rural_chronicle" true-label="1" false-label="0" label="鄉土紀事單元 Rural Chronicles Section" border></el-checkbox></div>
            <div class="tips">聚焦描繪亞洲鄉村生活、地域文化，深刻反映鄉土情懷、社會現實和人文精神的影像作品，擁抱每一種原生文化。</div>
            <div class="tips">Focuses on cinematic works portraying Asian rural life, regional cultures, and deeply reflecting local sentiments, social realities, and humanistic spirit, embracing every form of indigenous culture.</div>
          </div>
          <div class="mt-10">
            <div class="mb-5"><el-checkbox v-model="formData.auteur_film" true-label="1" false-label="0" label="作者電影單元 Auteur Films Section" border></el-checkbox></div>
            <div class="tips">聚焦導演作為電影“作者”的核心地位，遴選在視覺風格、敘事結構與主題表達上展現出高度統一性和鮮明個人印記的影片</div>
            <div class="tips">Focuses on the director's central role as the "author" of the film, selecting works that demonstrate a high degree of unity and distinctive personal signature in visual style, narrative structure, and thematic expression.</div>
          </div>
          <!-- <div class="mt-10">
            <div class="mb-5"><el-checkbox v-model="formData.artists_jury_special_award" true-label="1" false-label="0" label="藝術家評審團單元 Artists’Jury Special Award" border></el-checkbox></div>
            <div class="tips">由各個行業文化精英人士（包括非電影領域的藝術家）組成的評審團負責評選的單元，其評選標準側重於社會及大眾領域所偏好的電影作品。</div>
            <div class="tips">This section features a jury comprising cultural elites from various industries, including artists from non-film fields. Its selection criteria emphasize films with strong social relevance and broad public appeal.</div>
          </div> -->
          <div class="mt-10">
            <div class="mb-5"><el-checkbox v-model="formData.women_light" true-label="1" false-label="0" label="女性之光單元 Women's Light Section" border></el-checkbox></div>
            <div class="tips">尋找在女性視角中，打破傳統解析，重構女性主體，從“被看見”到“重構”女性的影像作品。</div>
            <div class="tips">Seeking cinematic works that, from a female perspective, break with traditional interpretations, reconstruct the female subject, and move from "being seen" to "reshaping" women.</div>
          </div>
      </el-collapse-item>

      <!-- 上傳影片、劇照及海報 -->
      <el-collapse-item title="" name="5">
        <template slot="title" >
          <div class="font-bold f-16">
            上傳影片、劇照及海報 Movie Uploads
          </div>
        </template>
        <div class="">
          <p>請在規定大小範圍內盡可能上傳清晰度高的圖片及影片。</p>
        </div>

        <!-- 海报 -->
        <el-form-item label="海報 2 張（豎版及橫版）(請至少上傳一張，每張海報大小在 5 MB以內) Posters (Size Limit: 5 MB)" prop="poster1">
            <div class="upload-buttons">

              <el-upload
                :action="upload_url"
                :before-upload="handleBeforeUpload"
                accept="image/*"
                :show-file-list="false"
                :on-success="handleSuccess"
                :on-error="handleError"
                :on-change="handleFileChange"
                :data="{'field':'poster1'}"
              >
                <img v-if="formData.poster1" :src="formData.poster1" class="multi-uploader-img">
                <div v-else class="multi-uploader"><span class="font-red font-size-20">*</span><i class="el-icon-plus "></i></div>
              </el-upload>

              <el-upload
                :action="upload_url"
                :before-upload="handleBeforeUpload"
                accept="image/*"
                :show-file-list="false"
                :on-success="handleSuccess"
                :on-error="handleError"
                :on-change="handleFileChange"
                :data="{'field':'poster2'}"
              >
                <img v-if="formData.poster2" :src="formData.poster2" class="multi-uploader-img">
                <i v-else class="el-icon-plus multi-uploader"></i>
              </el-upload>

            </div>
        </el-form-item>

        <!-- 剧照 -->

        <div class="mb-10 f-14"><span class="font-red">*</span> 劇照 (請至少上傳三張，每張劇照大小在 5 MB以內)  Film stills (size Limit: 5 MB)</div>
        
            <div class="upload-buttons">
              <el-form-item prop="stils1">
                <el-upload
                  :action="upload_url"
                  :before-upload="handleBeforeUploadLimit5M"
                  accept="image/*"
                  :show-file-list="false"
                  :on-success="handleSuccess"
                  :on-error="handleError"
                  :on-change="handleFileChange"
                  :data="{'field':'stils1'}"
                >
                  <img v-if="formData.stils1" :src="formData.stils1" class="multi-uploader-img">
                  <div v-else class="multi-uploader"><span class="font-red font-size-20">*</span><i class="el-icon-plus "></i></div>
                </el-upload>
              </el-form-item>

              <el-form-item prop="stils2">
                <el-upload
                  :action="upload_url"
                  :before-upload="handleBeforeUploadLimit5M"
                  accept="image/*"
                  :show-file-list="false"
                  :on-success="handleSuccess"
                  :on-error="handleError"
                  :on-change="handleFileChange"
                  :data="{'field':'stils2'}"
                >
                  <img v-if="formData.stils2" :src="formData.stils2" class="multi-uploader-img">
                  <div v-else class="multi-uploader"><span class="font-red font-size-20">*</span><i class="el-icon-plus "></i></div>
                </el-upload>
              </el-form-item>

              <el-form-item prop="stils3">
                <el-upload
                  :action="upload_url"
                  :before-upload="handleBeforeUploadLimit5M"
                  accept="image/*"
                  :show-file-list="false"
                  :on-success="handleSuccess"
                  :on-error="handleError"
                  :on-change="handleFileChange"
                  :data="{'field':'stils3'}"
                >
                  <img v-if="formData.stils3" :src="formData.stils3" class="multi-uploader-img">
                  <div v-else class="multi-uploader"><span class="font-red font-size-20">*</span><i class="el-icon-plus "></i></div>
                </el-upload>
              </el-form-item>

              <el-form-item prop="stils4">
                <el-upload
                  :action="upload_url"
                  :before-upload="handleBeforeUploadLimit5M"
                  accept="image/*"
                  :show-file-list="false"
                  :on-success="handleSuccess"
                  :on-error="handleError"
                  :on-change="handleFileChange"
                  :data="{'field':'stils4'}"
                >
                  <img v-if="formData.stils4" :src="formData.stils4" class="multi-uploader-img">
                  <i v-else class="el-icon-plus multi-uploader"></i>
                </el-upload>
              </el-form-item>

              <el-form-item prop="stils5">
                <el-upload
                  :action="upload_url"
                  :before-upload="handleBeforeUploadLimit5M"
                  accept="image/*"
                  :show-file-list="false"
                  :on-success="handleSuccess"
                  :on-error="handleError"
                  :on-change="handleFileChange"
                  :data="{'field':'stils5'}"
                >
                  <img v-if="formData.stils5" :src="formData.stils5" class="multi-uploader-img">
                  <i v-else class="el-icon-plus multi-uploader"></i>
                </el-upload>
              </el-form-item>

              <el-form-item prop="stils6">
                <el-upload
                  :action="upload_url"
                  :before-upload="handleBeforeUploadLimit5M"
                  accept="image/*"
                  :show-file-list="false"
                  :on-success="handleSuccess"
                  :on-error="handleError"
                  :on-change="handleFileChange"
                  :data="{'field':'stils6'}"
                >
                  <img v-if="formData.stils6" :src="formData.stils6" class="multi-uploader-img">
                  <i v-else class="el-icon-plus multi-uploader"></i>
                </el-upload>
              </el-form-item>
            </div>

        <!-- 片花/预告片 -->
        <!-- <el-form-item label="片花 / 預告片 (影片大小在 500 MB以內) Trailer (size Limit: 500 MB)" prop="trailer">
          <div class="">
            <video v-if="formData.trailer" height="200" controls :src="formData.trailer" preload="metadata" currentTime="0">
            </video>
            <el-upload
              :action="large_upload_url"
              :on-change="handleTrailerUpload"
              :before-upload="handleBeforeUploadLimit500M"
              accept="video/*"
              :on-exceed="handleExceed"
              :show-file-list="false"
              :auto-upload="false"
              :data="{'field':'trailer'}"
            >
              <el-button size="middle" plain type="primary"><span class="font-red ">*</span> 點擊上傳</el-button>
            </el-upload>
          </div>
           显示上传进度 
          <div v-if="uploadProgress.trailer && uploadProgress.trailer.status !== 'success'" class="upload-progress">
            <el-progress
              :percentage="uploadProgress.trailer.percentage">
            </el-progress>
          </div>
        </el-form-item> -->
        <el-form-item label="片花/預告片鏈接 Trailer / Teaser Link" prop="trailer_link">
            <div class="sub-title">請填寫可下載的分享鏈接（百度網盤、Vimeo、Google Drive 均可），僅供評審使用。</div>
            <div class="sub-title">Please provide a downloadable sharing link (via Baidu Netdisk, Vimeo, or Google Drive). This material is for review purposes only.</div>
            
            <el-input v-model="formData.trailer_link"></el-input>
        </el-form-item>

        <!-- 正片 - 支持分片上传 -->
          <!-- <el-form-item label="正片 (影片大小在 5 GB以內) Full Movie (Size Limit: 5 GB)" prop="full_movie">
            <div class="">
              <video v-if="full_movie_url" height="200" controls :src="full_movie_url" preload="metadata" currentTime="0">

              </video>
              <el-upload
                :action="large_upload_url"
                :on-change="handleFullMovieUpload"
                :before-upload="handleBeforeUploadLimit5G"
                :on-exceed="handleExceed"
                :show-file-list="false"
                :auto-upload="false"
                accept="video/*"
                :data="{'field':'full_movie'}"
              >
              <el-button size="middle" plain type="primary"><span class="font-red ">*</span> 點擊上傳</el-button>
              </el-upload>
            </div>

          显示上传进度
          <div v-if="uploadProgress.full_movie && uploadProgress.full_movie.status !== 'success'" class="upload-progress">
            <el-progress
              :percentage="uploadProgress.full_movie.percentage">
            </el-progress>
          </div> 
        </el-form-item>-->
          <el-form-item label="影片全片視頻鏈接 Full Film Video Link" prop="movie_link">
            <div class="sub-title">請填寫可下載的分享鏈接（百度網盤、Vimeo、Google Drive 均可），僅供評審使用。</div>
            <div class="sub-title">Please provide a downloadable sharing link (via Baidu Netdisk, Vimeo, or Google Drive). This material is for review purposes only.</div>
            
            <el-input v-model="formData.movie_link"></el-input>
          </el-form-item>
          
      </el-collapse-item>
    </el-collapse>

  </el-form>
    <!-- 提交按钮 -->
    <div class="submit-buttons">
      <el-button type="primary">保存進度 Save Progress</el-button>
      <el-button type="success"  @click="submitEntry">確認提交 Submit</el-button>
    </div>
    <div class="footer">
      <a href="https://beian.miit.gov.cn/" target="_blank">粤ICP备2025494802号-1</a>
    </div>
  </div>
</template>

<script>
import setting from '@/setting'
import md5 from 'js-md5'
export default {
  name: 'MovieEntry',
  data () {
    return {
      activeCollapse: '0',
      agreed: false,
      formData: {
        title: '',
        cate: '',
        country: '',
        language: '',
        subtitled: 'YES',
        subtitled_file: '',
        year_produced: '',
        length: '',
        summary: '',
        description: '',
        awards: '',
        executive_producer1: '',
        executive_producer1_avatar: '',
        executive_producer2: '',
        executive_producer2_avatar: '',
        executive_producer3: '',
        executive_producer3_avatar: '',
        executive_producer_more: '',
        director1: '',
        director1_avatar: '',
        director2: '',
        director2_avatar: '',
        director3: '',
        director3_avatar: '',
        director_more: '',
        screenwriter1: '',
        screenwriter1_avatar: '',
        screenwriter2: '',
        screenwriter2_avatar: '',
        screenwriter3: '',
        screenwriter3_avatar: '',
        screenwriter_more: '',
        actor1: '',
        actor1_avatar: '',
        actor2: '',
        actor2_avatar: '',
        actor3: '',
        actor3_avatar: '',
        actor4: '',
        actor4_avatar: '',
        actor5: '',
        actor5_avatar: '',
        actor6: '',
        actor6_avatar: '',
        actor_more: '',
        producer1: '',
        producer1_avatar: '',
        producer2: '',
        producer2_avatar: '',
        producer3: '',
        producer3_avatar: '',
        producer_more: '',
        cinematographer1: '',
        cinematographer1_avatar: '',
        cinematographer2: '',
        cinematographer2_avatar: '',
        cinematographer3: '',
        cinematographer3_avatar: '',
        cinematographer_more: '',
        art1: '',
        art1_avatar: '',
        art2: '',
        art2_avatar: '',
        art3: '',
        art3_avatar: '',
        art_more: '',
        company: '',
        contact: '',
        phone: '',
        email: '',
        business_license: '',
        pledge: '',
        main_competition: '0',
        pioneer_trend: '0',
        rural_chronicle: '0',
        auteur_film: '0',
        artists_jury_special_award: '0',
        women_light: '0',
        poster1: '',
        poster2: '',
        stils1: '',
        stils2: '',
        stils3: '',
        stils4: '',
        stils5: '',
        stils6: '',
        trailer: '',
        full_movie: '',
        trailer_link:'',
        movie_link:'',
      },
      uploads: {},
      largeFileUploadStatus: '',
      movieRules: {
        // agreed: [{ required: true, message: '請閱讀申報須知並同意遵守', trigger: 'change' }],
        title: [{ required: true, message: '請輸入電影名稱', trigger: 'blur' }],
        // cate: [{ required: true, message: '請輸入電影類型', trigger: 'blur' }],
        // country: [{ required: true, message: '請輸入國家', trigger: 'blur' }],
        // language: [{ required: true, message: '請輸入語言', trigger: 'blur' }],
        // subtitled: [{ required: true, message: '請輸入是否有字幕', trigger: 'blur' }],
        // year_produced: [{ required: true, message: '請輸入首映時間', trigger: 'blur' }],
        // length: [{ required: true, message: '請輸入片長', trigger: 'blur' }],
        // summary: [{ required: true, message: '請輸入一句話梗概', trigger: 'blur' }],
        // description: [{ required: true, message: '請輸入電影簡介', trigger: 'blur' }],
        // creator1: [{ required: true, message: '請輸入核心創作人及其作品簡介', trigger: 'blur' }],
        // company: [{ required: true, message: '請輸入出品單位', trigger: 'blur' }],
        // contact: [{ required: true, message: '請輸入聯絡人', trigger: 'blur' }],
        // phone: [{ required: true, message: '請輸入聯絡電話', trigger: 'blur' }],
        // email: [{ required: true, message: '請輸入Email', trigger: 'blur' }],
        // // business_license: [{ required: true, message: '請上傳營業執照', trigger: 'change' }],
        // pledge: [{ required: true, message: '請上傳承諾書照片', trigger: 'change' }],
        // executive_producer1: [{ required: true, message: '請輸入出品人姓名', trigger: 'blur' }],
        // executive_producer1_avatar: [{ required: true, message: '請上傳', trigger: 'change' }],
        // actor1: [{ required: true, message: '請填寫演員姓名', trigger: 'blur' }],
        // actor1_avatar: [{ required: true, message: '請上傳演員照片', trigger: 'blur' }],
        // actor2: [{ required: true, message: '請填寫演員姓名', trigger: 'blur' }],
        // actor2_avatar: [{ required: true, message: '請上傳演員照片', trigger: 'blur' }],
        // director1: [{ required: true, message: '請輸入導演姓名', trigger: 'blur' }],
        // director1_avatar: [{ required: true, message: '請上傳', trigger: 'change' }],
        // screenwriter1: [{ required: true, message: '請輸入編劇姓名和', trigger: 'blur' }],
        // screenwriter1_avatar: [{ required: true, message: '請上傳', trigger: 'change' }],
        // producer1: [{ required: true, message: '請輸入製作人姓名', trigger: 'blur' }],
        // producer1_avatar: [{ required: true, message: '請上傳', trigger: 'change' }],
        // cinematographer1: [{ required: true, message: '請輸入攝影姓名', trigger: 'blur' }],
        // cinematographer1_avatar: [{ required: true, message: '請上傳', trigger: 'change' }],
        // art1: [{ required: true, message: '請輸入美術姓名', trigger: 'blur' }],
        // art1_avatar: [{ required: true, message: '請上傳', trigger: 'change' }],
        // poster1: [{ required: true, message: '請上傳1張海報', trigger: 'change' }],
        // stils1: [{ required: true, message: '請上傳3張劇照', trigger: 'change' }],
        // stils2: [{ required: true, message: '請上傳3張劇照', trigger: 'change' }],
        // stils3: [{ required: true, message: '請上傳3張劇照', trigger: 'change' }],
        // trailer: [{ required: true, message: '請上傳片花', trigger: 'change' }],
        // full_movie: [{ required: true, message: '請上傳正片', trigger: 'change' }],
        
      },
      upload_url: setting.apiBaseURL + '/upload',
      large_upload_url: setting.apiBaseURL + '/large_upload',
      agreement_info_url: setting.apiBaseURL + '/agreement/info',
      uploadChunks: {}, // 用于存储分片上传的信息
      uploadProgress: {}, // 上传进度
      agreement_content:'',
      full_movie_url:'',
    }
  },
  // 页面创建时恢复数据
  created () {
    this.loadFormDataFromLocalStorage()
    document.title = '亞洲藝術電影節電影申報';
    this.getAgreementInfo()
  },
  // 监听 formData 变化并保存到 localStorage
  watch: {
    formData: {
      handler (newFormData) {
        this.saveFormDataToLocalStorage()
      },
      deep: true // 深度监听对象内部变化
    },
    agreed: {
      handler (newAgreed) {
        this.saveAgreedToLocalStorage()
      }
    },
    activeCollapse: {
      handler (newActiveCollapse) {
        this.saveActiveCollapseToLocalStorage()
      }
    }
  },
  methods: {
    addMember (type) {
      this.formData[type].push({ name: '' })
    },
    removeMember (type, index) {
      if (this.formData[type].length > 1) {
        this.formData[type].splice(index, 1)
      }
    },
    handleSuccess (rep, file, fileList) {
      console.log('handleSuccess')
      console.log(rep, file, fileList)
      if (typeof rep !== 'undefined' && typeof rep.status !== 'undefined' && rep.status === 200) {
        if (typeof rep.data.field !== 'undefined' && rep.data.url) {
          this.$set(this.formData, rep.data.field, rep.data.url)
        }
      }
    },
    handleAvatarSuccess (rep, file, fileList) {
      console.log('handleAvatarSuccess')
      console.log(rep, file, fileList)
    },

    handleError (err, file, fileList) {
      console.log(err, file, fileList)
    },
    handleFileChange (file, fileList) {
      console.log('handleFileChange', file)
      console.log(file, fileList)
      // const input = ''// event.target
      // if (input.files && input.files[0]) {
      //   this.formData[field] = input.files[0]
      // }
    },
    handleBeforeUpload (file) {
      if (file.size > 10 * 1024 * 1024) {
        this.$message.error('文件大小不能超過10MB')
        return false
      }
    },
    handleBeforeUploadLimit5M (file) {
      if (file.size > 10 * 1024 * 1024) {
        this.$message.error('文件大小不能超過10MB')
        return false
      }
    },
    handleBeforeUploadLimit500M (file) {
      if (file.size > 500 * 1024 * 1024) {
        this.$message.error('文件大小不能超過500MB')
        return false
      }
    },
    handleBeforeUploadLimit5G (file) {
      if (file.size > 5 * 1024 * 1024 * 1024) {
        this.$message.error('文件大小不能超過5GB')
        return false
      }
    },
    handleExceed (file, fileList) {
      this.$message.warning('只能上传一个文件')
    },
    downloadPledge () {
      window.open(setting.apiBaseURL+'/download_letter','blank');
    },
    //保存當前進度
    saveProgress () {
      this.saveFormDataToLocalStorage()
      this.$message.success('已保存當前進度')
    },
    // 保存 formData 到 localStorage
    saveFormDataToLocalStorage () {
      try {
        const formDataToSave = { ...this.formData }
        // 过滤掉可能无法序列化的属性（如文件对象等）
        localStorage.setItem('movieEntry_formData', JSON.stringify(formDataToSave))
      } catch (error) {
        console.error('保存 formData 到 localStorage 失败:', error)
      }
    },
    // 从 localStorage 加载 formData
    loadFormDataFromLocalStorage () {
      try {
        const savedFormData = localStorage.getItem('movieEntry_formData')
        if (savedFormData) {
          const parsedData = JSON.parse(savedFormData)
          // 合并保存的数据到当前 formData
          Object.assign(this.formData, parsedData)
          this.full_movie_url = parsedData.full_movie
        }

        // 加载其他保存的状态
        const savedAgreed = localStorage.getItem('movieEntry_agreed')
        if (savedAgreed !== null) {
          this.agreed = savedAgreed === 'true'
        }

        const savedActiveCollapse = localStorage.getItem('movieEntry_activeCollapse')
        if (savedActiveCollapse) {
          this.activeCollapse = savedActiveCollapse
        }
      } catch (error) {
        console.error('从 localStorage 加载数据失败:', error)
      }
    },

    // 保存 agreed 状态到 localStorage
    saveAgreedToLocalStorage () {
      try {
        localStorage.setItem('movieEntry_agreed', this.agreed.toString())
      } catch (error) {
        console.error('保存 agreed 到 localStorage 失败:', error)
      }
    },

    // 保存 activeCollapse 状态到 localStorage
    saveActiveCollapseToLocalStorage () {
      try {
        localStorage.setItem('movieEntry_activeCollapse', this.activeCollapse)
      } catch (error) {
        console.error('保存 activeCollapse 到 localStorage 失败:', error)
      }
    },

    // 清除 localStorage 中保存的数据
    clearLocalStorage () {
      try {
        localStorage.removeItem('movieEntry_formData')
        localStorage.removeItem('movieEntry_agreed')
        localStorage.removeItem('movieEntry_activeCollapse')
      } catch (error) {
        console.error('清除 localStorage 数据失败:', error)
      }
    },
    //提交
    submitEntry () {
      if (!this.agreed) {
        this.$message.error('請閱讀申報須知並同意遵守。')
        return
      }

      // 校验所有表单
      // this.$refs.movieForm.validate(valid => {
      //   if (!valid) return ''
      // })
      this.$refs.movieForm.validate((valid) => {
        if (!valid) {
          // this.$message.error('請完善必填信息！')
          this.$message.error('請輸入電影名稱')
          return
        }
        // 检查大文件上传状态
        // if (this.uploadProgress.full_movie && this.uploadProgress.full_movie.status !== 'success') {
        //   this.$message.error('請等待正片上傳完成！')
        //   return
        // }

        // if (this.uploadProgress.trailer && this.uploadProgress.trailer.status !== 'success') {
        //   this.$message.error('請等待片花/預告片上傳完成！')
        //   return
        // }
        if(this.formData.subtitled != 'YES'){
          if(this.formData.subtitled_file ==''){
            this.$message.error('請上傳字幕文檔 please upload subtitle file.')
            return
          }
        }
        // 显示提交确认对话框
        this.$confirm('確認提交申請資料嗎？提交後將無法修改。 <br>   Do you want to confirm and submit your application? Please note that it cannot be modified once submitted.', '確認提交 Confirm Submission', {
          confirmButtonText: '確認 Confirm',
          cancelButtonText: '取消 Cancel',
          type: 'warning',
          dangerouslyUseHTMLString: true
        }).then(() => {
          // 用户点击确认
          this.processSubmit()
        }).catch(() => {
          // return
        })
      })
    },
    async processSubmit () {
      // 显示加载状态
      const loading = this.$loading({
        lock: true,
        text: '資料提交中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      try {
        // 准备提交数据
        // const submitData = {
        //   title: this.formData.title,
        //   cate: this.formData.cate,
        //   country: this.formData.country,
        //   language: this.formData.language,
        //   subtitled: this.formData.subtitled,
        //   year_produced: this.formData.year_produced,
        //   length: this.formData.length,
        //   summary: this.formData.summary,
        //   description: this.formData.description,
        //   awards: this.formData.awards,
        //   executive_producer1: this.formData.executive_producer1,
        //   executive_producer1_avatar: this.formData.executive_producer1_avatar,
        //   executive_producer2: this.formData.executive_producer2,
        //   executive_producer2_avatar: this.formData.executive_producer2_avatar,
        //   executive_producer3: this.formData.executive_producer3,
        //   executive_producer3_avatar: this.formData.executive_producer3_avatar,
        //   executive_producer_more: this.formData.executive_producer_more,
        //   director1: this.formData.director1,
        //   director1_avatar: this.formData.director1_avatar,
        //   director2: this.formData.director2,
        //   director2_avatar: this.formData.director2_avatar,
        //   director3: this.formData.director3,
        //   director3_avatar: this.formData.director3_avatar,
        //   director_more: this.formData.director_more,
        //   screenwriter1: this.formData.screenwriter1,
        //   screenwriter1_avatar: this.formData.screenwriter1_avatar,
        //   screenwriter2: this.formData.screenwriter2,
        //   screenwriter2_avatar: this.formData.screenwriter2_avatar,
        //   screenwriter3: this.formData.screenwriter3,
        //   screenwriter3_avatar: this.formData.screenwriter3_avatar,
        //   screenwriter_more: this.formData.screenwriter_more,
        //   actor1: this.formData.actor1,
        //   actor1_avatar: this.formData.actor1_avatar,
        //   actor2: this.formData.actor2,
        //   actor2_avatar: this.formData.actor2_avatar,
        //   actor3: this.formData.actor3,
        //   actor3_avatar: this.formData.actor3_avatar,
        //   actor4: this.formData.actor4,
        //   actor4_avatar: this.formData.actor4_avatar,
        //   actor5: this.formData.actor5,
        //   actor5_avatar: this.formData.actor5_avatar,
        //   actor6: this.formData.actor6,
        //   actor6_avatar: this.formData.actor6_avatar,
        //   actor_more: this.formData.actor_more,
        //   producer1: this.formData.producer1,
        //   producer1_avatar: this.formData.producer1_avatar,
        //   producer2: this.formData.producer2,
        //   producer2_avatar: this.formData.producer2_avatar,
        //   producer3: this.formData.producer3,
        //   producer3_avatar: this.formData.producer3_avatar,
        //   producer_more: this.formData.producer_more,
        //   cinematographer1: this.formData.cinematographer1,
        //   cinematographer1_avatar: this.formData.cinematographer1_avatar,
        //   cinematographer2: this.formData.cinematographer2,
        //   cinematographer2_avatar: this.formData.cinematographer2_avatar,
        //   cinematographer3: this.formData.cinematographer3,
        //   cinematographer3_avatar: this.formData.cinematographer3_avatar,
        //   cinematographer_more: this.formData.cinematographer_more,
        //   art1: this.formData.art1,
        //   art1_avatar: this.formData.art1_avatar,
        //   art2: this.formData.art2,
        //   art2_avatar: this.formData.art2_avatar,
        //   art3: this.formData.art3,
        //   art3_avatar: this.formData.art3_avatar,
        //   art_more: this.formData.art_more,
        //   company: this.formData.company,
        //   contact: this.formData.contact,
        //   phone: this.formData.phone,
        //   email: this.formData.email,
        //   business_license: this.formData.business_license,
        //   pledge: this.formData.pledge,
        //   main_competition: this.formData.main_competition,
        //   pioneer_trend: this.formData.pioneer_trend,
        //   rural_chronicle: this.formData.rural_chronicle,
        //   auteur_film: this.formData.auteur_film,
        //   artists_jury_special_award: this.formData.artists_jury_special_award,
        //   poster1: this.formData.poster1,
        //   poster2: this.formData.poster2,
        //   stils1: this.formData.stils1,
        //   stils2: this.formData.stils2,
        //   stils3: this.formData.stils3,
        //   stils4: this.formData.stils4,
        //   stils5: this.formData.stils5,
        //   stils6: this.formData.stils6,
        //   trailer: this.formData.trailer,
        //   full_movie: this.formData.full_movie
        // }

        // 发送提交请求
        const response = await fetch(`${setting.apiBaseURL}/submit_film`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(this.formData)
        })
        const result = await response.json()
        // 关闭加载状态
        loading.close()

        if (result.status==200) {
          // 提交成功
          this.$message.success('申請資料提交成功。Submission Successful.')
          // 清除本地存储的数据
          this.clearLocalStorage()
          // 可以选择跳转到成功页面或重置表单
          // this.$router.push('/success')
          // 或者重置表单
          // this.resetForm()
        } else {
          // 提交失败
          this.$message.error(result.msg || '提交失敗，請稍後重試。Submission Failed. Please try again later.')
        }
      } catch (error) {
        // 关闭加载状态
        if (loading) {
          loading.close()
        }
        console.error('提交失敗:', error)
        this.$message.error('提交失敗，請檢查網絡連接後重試。Submission Failed. Please check your network connection and try again later.')
      }
    },
    async handleFullMovieUpload (file, fileList) {
      console.log('开始处理大文件上传', file)

      // 检查文件大小
      if (file.size > 5 * 1024 * 1024 * 1024) {
        this.$message.error('文件大小不能超過5GB')
        return false
      }

      const fieldName = 'full_movie'

      // 初始化上传进度
      this.$set(this.uploadProgress, fieldName, {
        percentage: 0,
        uploadedChunks: 0,
        totalChunks: 0,
        status: ''
      })
      console.log('this.uploadProgress 1', this.uploadProgress)

      try {
        // 开始分片上传
        await this.startChunkedUpload(file.raw || file, fieldName)
      } catch (error) {
        console.error('上傳失敗:', error)
        this.$set(this.uploadProgress, fieldName, {
          percentage: 0,
          uploadedChunks: 0,
          totalChunks: 0,
          status: 'exception'
        })
        this.$message.error('上傳失敗: ' + error.message)
      }
    },
    async handleTrailerUpload (file, fileList) {
      console.log('开始处理片花文件上传', file)

      // 检查文件大小
      if (file.size > 500 * 1024 * 1024) {
        this.$message.error('文件大小不能超過500MB')
        return false
      }

      const fieldName = 'trailer'

      // 初始化上传进度
      this.$set(this.uploadProgress, fieldName, {
        percentage: 0,
        uploadedChunks: 0,
        totalChunks: 0,
        status: ''
      })
      console.log('this.uploadProgress 1', this.uploadProgress)

      try {
        // 开始分片上传
        await this.startChunkedUpload(file.raw || file, fieldName)
      } catch (error) {
        console.error('上传失败:', error)
        this.$set(this.uploadProgress, fieldName, {
          percentage: 0,
          uploadedChunks: 0,
          totalChunks: 0,
          status: 'exception'
        })
        this.$message.error('上传失败1: ' + error.message)
      }
    },
    // 分片上传主逻辑
    async startChunkedUpload (file, fieldName) {
      const chunkSize = 2 * 1024 * 1024 // 2MB 每块
      const fileSize = file.size
      const totalChunks = Math.ceil(fileSize / chunkSize)
      console.log('totalChunks', totalChunks)
      // 更新进度信息
      this.$set(this.uploadProgress, fieldName, {
        percentage: 0,
        uploadedChunks: 0,
        totalChunks: totalChunks,
        status: ''
      })
      console.log('this.uploadProgress', this.uploadProgress)

      this.largeFileUploadStatus = `开始上传，共 ${totalChunks} 块`

      // 生成文件唯一标识
      const fileId = this.generateFileId(file)

      // 存储上传信息
      this.$set(this.uploadChunks, fileId, {
        chunks: [],
        uploadedChunks: 0,
        totalChunks: totalChunks
      })

      try {
        // 1. 先通知服务器准备接收文件
        const initResponse = await this.initiateUpload(file, fieldName, fileId, totalChunks)

        if (!initResponse.success) {
          throw new Error('初始化上传失败')
        }

        // 2. 逐个上传分片
        for (let i = 0; i < totalChunks; i++) {
          const start = i * chunkSize
          const end = Math.min(start + chunkSize, fileSize)
          const chunk = file.slice(start, end)

          // 上传单个分片
          await this.uploadChunk(chunk, i, fileId, fieldName, file)

          // 更新进度
          const uploadedChunks = i + 1
          const percentage = Math.round((uploadedChunks / totalChunks) * 10000)/100
          console.log('percentage:', percentage, uploadedChunks, totalChunks)
          this.$set(this.uploadProgress, fieldName, {
            percentage: percentage,
            uploadedChunks: uploadedChunks,
            totalChunks: totalChunks,
            status: ''
          })

          this.largeFileUploadStatus = `已上传 ${uploadedChunks}/${totalChunks} 块 (${percentage}%)`
        }

        // 3. 通知服务器合并文件
        const mergeResponse = await this.mergeChunks(fileId, fieldName, file.name, file.size)

        if (mergeResponse.success) {
          this.$set(this.uploadProgress, fieldName, {
            percentage: 100,
            uploadedChunks: totalChunks,
            totalChunks: totalChunks,
            status: 'success'
          })

          this.largeFileUploadStatus = '上传完成！'

          // 保存文件URL到formData
          this.$set(this.formData, fieldName, mergeResponse.url || mergeResponse.data.uri)
          if(fieldName == 'full_movie'){
            this.full_movie_url = mergeResponse.data.url
          }
          

          this.$message.success(`${file.name} 上传成功！`)
        } else {
          throw new Error('文件合并失败')
        }
      } catch (error) {
        this.$set(this.uploadProgress, fieldName, {
          percentage: 0,
          uploadedChunks: 0,
          totalChunks: totalChunks,
          status: 'error'
        })

        this.largeFileUploadStatus = '上传失败2: ' + error.message
        throw error
      }
    },

    // 初始化上传
    async initiateUpload (file, fieldName, fileId, totalChunks) {
      const formData = new FormData()
      formData.append('action', 'init')
      formData.append('fileId', fileId)
      formData.append('fileName', file.name)
      formData.append('fileSize', file.size)
      formData.append('totalChunks', totalChunks)
      formData.append('fieldName', fieldName)

      try {
        const response = await fetch(this.large_upload_url, {
          method: 'POST',
          body: formData
        })

        return await response.json()
      } catch (error) {
        throw new Error('初始化上传失败2: ' + error.message)
      }
    },

    // 上传单个分片
    async uploadChunk (chunk, chunkIndex, fileId, fieldName, file) {
      return new Promise((resolve, reject) => {
        const formData = new FormData()
        formData.append('action', 'upload')
        formData.append('fileId', fileId)
        formData.append('chunkIndex', chunkIndex)
        formData.append('chunk', chunk)
        formData.append('fileName', file.name)
        formData.append('fieldName', fieldName)

        const xhr = new XMLHttpRequest()

        xhr.upload.addEventListener('progress', (e) => {
          if (e.lengthComputable) {
            const chunkProgress = Math.round((e.loaded / e.total) * 100)
            // console.log(`分片 ${chunkIndex + 1} 上传进度: ${chunkProgress}%`)
            // let uploadProgress = this.uploadProgress[fieldName]
            // uploadProgress.percentage = uploadProgress.percentage+'.'+chunkProgress
            // this.$set(this.uploadProgress, fieldName, uploadProgress)
          }
        })

        xhr.addEventListener('load', () => {
          if (xhr.status === 200) {
            try {
              const response = JSON.parse(xhr.responseText)
              if (response.success) {
                resolve(response)
              } else {
                reject(new Error(response.message || '分片上传失败'))
              }
            } catch (e) {
              reject(new Error('解析响应失败'))
            }
          } else {
            reject(new Error(`HTTP ${xhr.status}: ${xhr.statusText}`))
          }
        })

        xhr.addEventListener('error', () => {
          reject(new Error('网络错误'))
        })

        xhr.open('POST', this.large_upload_url)
        xhr.send(formData)
      })
    },

    // 合并分片
    async mergeChunks (fileId, fieldName, fileName, fileSize) {
      const formData = new FormData()
      formData.append('action', 'merge')
      formData.append('fileId', fileId)
      formData.append('fileName', fileName)
      formData.append('fileSize', fileSize)
      formData.append('fieldName', fieldName)

      try {
        const response = await fetch(this.large_upload_url, {
          method: 'POST',
          body: formData
        })

        return await response.json()
      } catch (error) {
        throw new Error('合并文件失败3: ' + error.message)
      }
    },

    // 生成文件唯一标识
    generateFileId (file) {
      const timestamp = new Date().getTime()
      const random = Math.random().toString(36).substr(2, 9)
      const file_name = md5(file.name)
      return `${file_name}_${file.size}_${timestamp}_${random}`
    },

    // 暂停上传
    pauseUpload (fieldName) {
      // 实际项目中需要实现暂停逻辑
      this.$message.info('暂停上传功能待实现')
    },

    // 恢复上传
    resumeUpload (fieldName) {
      // 实际项目中需要实现恢复逻辑
      this.$message.info('恢复上传功能待实现')
    },

    // 取消上传
    cancelUpload (fieldName) {
      // 实际项目中需要实现取消逻辑
      this.$message.info('取消上传功能待实现')
    },
    getAgreementInfo() { 
        const response = this.request(this.agreement_info_url,"POST",{type:'1'})
        response.then(data=>{
          if(data.status == 200){
            this.agreement_content = data.data.content
          }
        }).catch(error=>{
          console.log('error',error)
        })
    },
    async request(url,method,data){
      try {
        const response = await fetch(url, {
          method: method,
          headers: {
            'Content-Type': 'application/json' // 设置内容类型为JSON
          },
          body: JSON.stringify(data)
        })
        return await response.json()
      } catch (error) {
        throw new Error('request error: ' + error.message)
      }
    }
  }
}
</script>

<style scoped>
.movie-entry-container {
  font-family: Arial, sans-serif;
  background-color: white;
  color: #333;
  padding: 20px;
  text-align: left;
  max-width: 1000px;
  margin: 0 auto;
  font-size: 14px;
}

.title-section {
  display: flex;
  justify-content: flex-start;
  text-align: left;
  margin-bottom: 20px;
  gap: 15px;
  height: 50px;
  line-height: 50px;
}

.title-section h1 {
  font-size: 1em;
  margin: 0;
}

.title-section p {
  font-size: 1em;
  margin: 5px 0 0 0;
  color: #666;
}

.form-section {
  margin-bottom: 20px;
}

.upload-instructions {
  margin-bottom: 20px;
  padding: 10px;
  background-color: #f8f9fa;
  border: 1px solid #ddd;
  border-radius: 4px;
}

.upload-section {
  margin-bottom: 20px;
}

.upload-buttons {
  display: flex;
  gap: 10px;
  margin-top: 10px;
}

.pledge-buttons {
  /* display: flex; */
  /* gap: 10px; */
  margin-top: 10px;
}
.pledge-buttons .pledge-down{
  padding: 10px;
}

.category-buttons {
  display: flex;
  gap: 10px;
  margin-top: 10px;
  font-size: 14px;
}

.submit-buttons {
  margin-top: 20px;
  display: flex;
  gap: 10px;
}

.upload-status {
  margin-top: 10px;
  color: #666;
}
.el-input__inner{
  height: 30px !important;
  line-height: 30px !important;
}
.h-30{
  height: 30px;
  line-height: 30px;
}
.sub-title{
  height: 20px;
  line-height: 20px;
  font-size: 12px;
}
.mb-10{
  margin-bottom: 10px;
}
.mb-5{
  margin-bottom: 5px;
}
.font-bold{
  font-weight: bold;
}
.f-14{
  font-size: 14px;
}
.f-16{
  font-size: 16px;
}
.input-upload {
  display: flex;
  gap: 2px;
}
.upload-plus{
  border: 1px dashed #ccc;
  height: 38px;
  line-height: 38px;
  padding: 0 10px;
}
.upload-img{
  height: 32px;
  margin-top:3px;
}
.logo-section{
  width: 50px;
}
.business-uploader{
  height: 150px;
}
.multi-uploader{
  width: 145px;
  height: 145px;
  line-height: 145px;
  font-size: 28px;
  border: 1px dashed #c0ccda;
  background-color: #fbfdff;
  color: #8c939d;
  text-align: center;
}
.multi-uploader-img{
  width: 145px;
  padding: 5px;
  border: 1px dashed #c0ccda;
}
.submission-font-red{
    color: red;
  }
.font-red{
  color: red;
  width: 0px;
  display: none;
}
.mt-10{
  margin-top: 10px;
}
.font-size-20{
  font-size: 20px;
}
.input-upload-avatar{
  width: 50px;
  text-align: center;
}
.footer{
  text-align: center;
  margin-top: 20px;
  font-size: 12px;
  color: #666;
  line-height: 40px;
  height: 40px;
}
.footer a{
  color: #666;
  text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/pages/index/index.vue